import { typeMetaEnum, EnumMetaType } from "@/autogen/common";
import { CountryCode } from "./CountryCode";

export type CountryCodeMetaI = EnumMetaType<typeof CountryCode, CountryCode>;
export const CountryCodeMeta = typeMetaEnum<typeof CountryCode, CountryCode>("CountryCode", CountryCode);

